import { useEffect, useState } from "react";
import { toast } from "sonner";
import { API_ENDPOINTS } from "../utils/urls";
import api from "../utils/api";

interface Props {
  setShowForm: (value: boolean) => void;
  editData?: any;
}

const EditItem: React.FC<Props> = ({ setShowForm, editData }) => {
  const [variants, setVariants] = useState<
    {
      variantId: string;
      variantName: string;
      price: number;
      stock: number;
      sku: string;
    }[]
  >([]);

  useEffect(() => {
    if (editData?.variants) {
      const variantData = editData.variants.map((v: any) => ({
        variantId: v.variantId,
        variantName: v.variantName,
        price: v.price,
        stock: v.stock,
        sku: v.sku || "",
      }));
      setVariants(variantData);
    }
  }, [editData]);

  useEffect(() => {
    const handleKeyDown = (e: any) => {
      if (e.key === "Escape") setShowForm(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    field: "price" | "stock" | "sku"
  ) => {
    const value = e.target.value;
    const updated = [...variants];

    if (field === "price" || field === "stock") {
      updated[index][field] = Number(value);
    } else {
      updated[index][field] = value;
    }

    setVariants(updated);
  };

  const handleSubmit = async () => {
    try {
      await api.put(API_ENDPOINTS.INVENTORY.EDIT_DATA, {
        itemId: editData.itemId,
        variants,
      });
      toast.success("Item variants updated successfully!");
      setShowForm(false);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("Failed to update variants");
      console.error(error);
    }
  };

  return (
    <div className="mt-6">
      <h2 className="text-xl font-bold mb-4">{editData?.name}</h2>

      {variants.map((variant, i) => (
        <div
          key={variant.variantId}
          className="mb-6 border p-4 rounded bg-gray-50 shadow-sm"
        >
          <p className="text-md font-semibold mb-2">
            Variant: {variant.variantName}
          </p>
          <input
            type="number"
            placeholder="Price"
            value={variant.price}
            onChange={(e) => handleChange(e, i, "price")}
            className="w-full border p-2 mb-2"
          />
          <input
            type="number"
            placeholder="Stock"
            value={variant.stock}
            onChange={(e) => handleChange(e, i, "stock")}
            className="w-full border p-2 mb-2"
          />
          <input
            type="text"
            placeholder="SKU"
            value={variant.sku}
            onChange={(e) => handleChange(e, i, "sku")}
            className="w-full border p-2"
          />
        </div>
      ))}

      <button
        onClick={handleSubmit}
        className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
      >
        Update Variants
      </button>
    </div>
  );
};

export default EditItem;
